import React, { useEffect } from 'react';
import useToken from 'hooks/useToken';
import { useNavigate } from 'react-router-dom';



import { Col, Row } from 'react-bootstrap';

import Greetings from './Greeting/Greetings';
import ListaGastos from './ListaGastos';
import { useToast } from 'context/providers/ToastProvider';


const Gastos = () => {

    const { token, idCatTipoUsuario } = useToken();
    const navigate = useNavigate();
    const { showErrorToast } = useToast();

    const [showModalRegistrarGasto, setShowModalRegistrarGasto] = React.useState(false);
    const [showModalNuevo, setShowModalNuevo] = React.useState(false);

    /**
      * Se ejecuta la primera vez
      */
    useEffect(() => {

        if (idCatTipoUsuario != 1) {
            navigate("/");
        }

        checkPermisos();
    }, []);

    /**
     * Verifica los permisos
     */
    const checkPermisos = async () => {

        const response = await fetch("/api/Administradores/checkPermisos",
            {
                method: 'POST',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const responseType = await response.json();
            console.log(responseType);

            if (responseType.iResponseType == 1) {
                //
            } else {
                navigate("/");
            }

        }
        else {
            navigate("/");
        }
    }


    return (
        <>

            <Row>
                <Col className="col-12">
                    <Greetings
                        setShowModalRegistrarGasto={setShowModalRegistrarGasto}
                        setShowModalNuevo={setShowModalNuevo}/>

                </Col>
                <Col className="col-12">
                    <ListaGastos
                        setShowModalRegistrarGasto={setShowModalRegistrarGasto}
                        showModalRegistrarGasto={showModalRegistrarGasto}
                        setShowModalNuevo={setShowModalNuevo}
                        showModalNuevo={showModalNuevo}
                    />
                </Col>

            </Row>


        </>
    );
};

export default Gastos;